// extracted by mini-css-extract-plugin
export default {"app_link":"styles_app_link__J+xUX","primary":"styles_primary__ao+Dx","secondary":"styles_secondary__7lJGO","red":"styles_red__XGBgz","active":"styles_active__YbDBO"};